module.exports = __webpack_public_path__ + "img/260720945_1_9.f61e6599.png";